import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from 'material-ui/Typography';
import Radium from 'radium';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';

const styles = {
  fileCell: {
    display: 'flex',
    boxSizing: 'border-box',
    height: '72px',
    fontSize: '14px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    fontSize: '12px',
    color: '#444',
    marginBottom: '8px',
    textTransform: 'uppercase',
  },
  container: {
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0,0,0,0.02)',
    borderBottom: '1px solid #e8e8e8',
  },
  noFiles: {
    color: '#999',
  },
  dropzoneContainer: {
    color: '#000',
    padding: '16px',
    ':hover': {
      backgroundColor: 'rgba(0,0,0,0.04)',
    },
  },
  dropzone: {
    display: 'flex',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    border: '1px dashed #999',
    cursor: 'default',
  },
  filesList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  fileItem: {
    justifyContent: 'space-between',
    ':hover': {
      backgroundColor: 'rgba(0,0,0,0.04)',
    },
  },
  fileInfo: {
    display: 'flex',
    flexGrow: 1,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  leftIcon: {
    marginRight: '16px',
  },
  infoContainer: {
    flexGrow: 1,
  },
  fileActions: {
    paddingRight: '16px',
  },
  captionTextField: {
    width: '100%',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
};

var dataDeleteIndex = null;

class SLUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: this.props.files !== undefined ? this.props.files : [],
      openConfirm: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      files: nextProps.files,
    });
  }

  onDrop(droppedFiles) {
    let newFiles = JSON.parse(JSON.stringify(this.state.files));

    droppedFiles.forEach((file) => {
      let newFileName =
        Math.floor(Math.random() * 90000) + 10000 + '_' + file.name;
      const f = { name: newFileName, comments: '', progress: 0 };

      //Upload to server
      var data = new FormData();
      data.append('file', file, newFileName);
      var config = {
        onUploadProgress: function (progressEvent) {
          Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      };
      axios
        .post(
          process.env.REACT_APP_URL_API + '/api/containers/files/upload',
          data,
          config
        )
        .then(function (res) {
          console.log(res);
        })
        .catch(function (err) {});

      newFiles.push(f);
    });

    this.props.onChange(newFiles);

    this.setState({ files: newFiles });
  }

  handleCommentsChange = (event, index) => {
    let newFiles = JSON.parse(JSON.stringify(this.state.files));
    newFiles[index].comments = event.target.value;
    this.props.onChange(newFiles);
    this.setState({ files: newFiles });
  };

  onDelete = (confirm, index) => {
    if (index !== undefined) dataDeleteIndex = index;

    let _this = this;
    let newFiles = [...this.state.files];

    if (confirm) {
      var nameToDelete = newFiles[dataDeleteIndex].name;

      axios
        .delete(
          process.env.REACT_APP_URL_API +
            '/api/containers/files/files/' +
            nameToDelete
        )
        .then(function (res) {
          console.log(res);
        })
        .catch(function (err) {});

      //Todo: revisar si cada que se guarda se puede borrar también en el servidor o como hacerle.
      newFiles.splice(dataDeleteIndex, 1);
      _this.props.onChange(newFiles);
      _this.setState({ files: newFiles, openConfirm: false });
    } else {
      this.setState({ openConfirm: true });
    }
  };

  render() {
    const { label, accept, multiple } = this.props;
    const { files, openConfirm } = this.state;

    return (
      <div>
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro de borrar el archivo?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        <h5 style={styles.label}>{label}</h5>
        <div style={styles.container}>
          {/* Files list */}
          <ul style={styles.filesList}>
            {files.map((file, index) => {
              return (
                <li key={index} style={[styles.fileCell, styles.fileItem]}>
                  <div style={styles.fileInfo}>
                    <Avatar style={styles.leftIcon}>
                      <FolderIcon />
                    </Avatar>
                    <div style={styles.infoContainer}>
                      <Typography variant="body2" style={{ fontSize: 13 }}>
                        <a
                          href={
                            process.env.REACT_APP_URL_API +
                            '/api/containers/files/download/' +
                            file.name
                          }
                          target="_blank"
                        >
                          Ver el archivo {file.name}
                        </a>
                      </Typography>
                      <input
                        type="text"
                        style={styles.captionTextField}
                        placeholder="Escribe un comentarios..."
                        value={file.comments}
                        onChange={(event) =>
                          this.handleCommentsChange(event, index)
                        }
                      />
                    </div>
                  </div>
                  <div style={styles.fileActions}>
                    <IconButton
                      aria-label="Delete"
                      onClick={(event) => this.onDelete(false, index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </li>
              );
            })}
          </ul>
          {/* Files list */}

          {/* Dropzone */}
          {multiple ? (
            <div style={[styles.fileCell, styles.dropzoneContainer]}>
              <Dropzone
                accept={accept}
                onDrop={this.onDrop.bind(this)}
                style={styles.dropzone}
                multiple={multiple ? true : false}
              >
                <p>Arrastra tus archivos o haz click aquí</p>
              </Dropzone>
            </div>
          ) : files.length === 0 ? (
            <div style={[styles.fileCell, styles.dropzoneContainer]}>
              <Dropzone
                accept={accept}
                onDrop={this.onDrop.bind(this)}
                style={styles.dropzone}
                multiple={multiple ? true : false}
              >
                <p>Arrastra el archivos o haz click aquí</p>
              </Dropzone>
            </div>
          ) : null}
          {/* Dropzone */}
        </div>
      </div>
    );
  }
}

SLUpload.propTypes = {
  label: PropTypes.string.isRequired,
};

export default Radium(SLUpload);



// WEBPACK FOOTER //
// ./src/lib/upload.js